export default "__VITE_ASSET__D_zfOmmK__"